import { IAddOpportunityFormModel } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { useFormikContext } from 'formik'
import { useMemo } from 'react'
import { getLocationAddress } from '@user/store/entityLocations'

export function useData() {
  const { errors, touched, values, submitCount, setFieldValue } =
    useFormikContext<IAddOpportunityFormModel>()

  const serviceOptions = useMemo(
    () =>
      values.serviceLocations?.map((l) => ({
        value: l.id.toString(),
        label: `${l.locationCode} - ${getLocationAddress(l)}`,
      })) || [],
    [values.serviceLocations],
  )

  return {
    errors,
    values,
    touched,
    serviceOptions,
    submitCount,
    setFieldValue,
  }
}
